export const SET_CUSTOM_LISTS = 'CUSTOM_LIST/SET_CUSTOM_LISTS'
export const SET_CUSTOM_LIST = 'CUSTOM_LIST/SET_CUSTOM_LIST'
export const SET_CUSTOM_LIST_ITEMS = 'CUSTOM_LIST/SET_CUSTOM_LIST_ITEMS'
